module.exports = __webpack_public_path__ + "static/media/textBubbles.7aff44ba.png";